class BayeuxMenuDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.openButton = this.querySelector('[data-drawer-open]');
    if (!this.dialog || !this.openButton) return;

    this.openButton.addEventListener('click', () => this.open());
    this.dialog.addEventListener('click', (event) => this.onClick(event));
    this.dialog.addEventListener('close', () => this.onClose());
  }

  open() {
    this.showPanel('main', false);
    this.dialog.showModal();
    this.openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-drawer-open');
  }

  close() {
    this.dialog.close();
  }

  onClose() {
    this.openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-drawer-open');
    this.openButton.focus();
  }

  onClick(event) {
    if (event.target === this.dialog) {
      const rect = this.dialog.getBoundingClientRect();
      const outside =
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom;
      if (outside) this.close();
      return;
    }

    if (event.target.closest('[data-drawer-close]')) {
      this.close();
      return;
    }

    const panelTrigger = event.target.closest('[data-open-panel]');
    if (panelTrigger) this.showPanel(panelTrigger.dataset.openPanel, true, panelTrigger, event.detail === 0);
  }

  showPanel(name, moveFocus, trigger, fromKeyboard = false) {
    const previous = this.dialog.querySelector('.menu-drawer__panel:not([hidden])');
    const next = this.dialog.querySelector(`.menu-drawer__panel[data-panel="${CSS.escape(name)}"]`);
    if (!next) return;

    this.dialog.querySelectorAll('.menu-drawer__panel').forEach((panel) => {
      panel.hidden = panel !== next;
    });
    next.scrollTop = 0;

    if (!moveFocus) return;
    const returning = previous && trigger && trigger.classList.contains('drawer-item--back');
    const target = returning
      ? next.querySelector(`[data-open-panel="${CSS.escape(previous.dataset.panel)}"]`)
      : next.querySelector('a, button, input');
    target?.focus({ focusVisible: fromKeyboard });
  }
}

customElements.define('bayeux-menu-drawer', BayeuxMenuDrawer);
